import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
//import Banner from './Banner';
//import ProductsAll from './allprojects/ProjectsAll';
import Account from './Account';
import { Link } from 'react-router-dom';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import user1 from 'assets/img/team/1.jpg';
import user2 from 'assets/img/team/2.jpg';
import user3 from 'assets/img/team/3.jpg';
//import ProjectsMain from './allprojects/projectsMain';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
//import { courseData } from 'data/elearning/courseData';
import AllPorjects from './AllPorjects';
import useProject from './useProject';

const Projects = () => {
 const { data } = useProject({ query: true });
 //if (!data) return <Charging />;
 return (
  <>
   <Row className="g-3 mt-0">
    <Col lg={9}>
     {data ? (
      <AllPorjects data={data} />
     ) : (
      <Card className="bg-transparent shadow-none py-3">
       <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
        <div className="fs--1">
         <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
         <h5>¡No se han encontrado proyectos!</h5>
         <p className="mb-0">Su búsqueda no coincidió con ningún proyecto. Inténtalo de nuevo o crea un nuevo proyecto</p>
        </div>
       </Card.Body>
      </Card>
     )}
    </Col>
    <Col lg={3}>
     <div className="sticky-sidebar">
      <Card className="mb-3">
       <Card.Header className="pb-0">
        <Flex justifyContent="between">
         <div>
          <p className="mb-1 fs--2 text-500">Pruebalo gratis</p>
          <Flex>
           {/* <span className="fa-stack me-2 ms-n1">
            <FontAwesomeIcon icon="circle" className="fa-stack-2x text-100" />
            <FontAwesomeIcon icon="home" className="fa-inverse fa-stack-1x text-primary" />
           </span> */}
           <div className="flex-1">
            <h5 className="mb-0 text-primary position-relative">
             <span className="pe-3">Nuevo Proyecto</span>
             <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
            </h5>
            <p className="mb-0 fs--2">Crear nunca fue tan facil.</p>
           </div>
          </Flex>
         </div>
         <div className="bg-soft-primary p-3 rounded-circle text-center" style={{ width: '60px', height: '60px' }}>
          <h5 className="text-primary mb-0 d-flex flex-column mt-n1">
           <span>30</span>
           <small className="text-primary fs--2 lh-1">DIAS</small>
          </h5>
         </div>
        </Flex>

        <ul className="fa-ul ms-2 ps-x1 mb-0 mt-3">
         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Ahorra tiempo
          </h6>
         </li>

         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Proyecta el futuro
          </h6>
         </li>

         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Estadisticas en tiempo real
          </h6>
         </li>
        </ul>
       </Card.Header>

       <Card.Body as={Flex} wrap="wrap" justifyContent="center" alignItems="center">
        <div className="flex-grow-1">
         <Link className="btn btn-sm btn-link ps-0" to="#!">
          Chatea con nosotros!
         </Link>
        </div>

        <div>
         <AvatarGroup dense>
          {[
           {
            id: 1,
            img: user1,
            size: 'xl'
           },
           {
            id: 2,
            img: user2,
            size: 'xl'
           },
           {
            id: 3,
            img: user3,
            size: 'xl'
           },
           {
            id: 4,
            name: '+50',
            size: 'xl'
           }
          ].map(({ img, name, size, id }) => {
           return (
            <Avatar
             src={img && img}
             key={id}
             size={size}
             name={name && name}
             isExact
             className="border border-3 rounded-circle border-light"
            />
           );
          })}
         </AvatarGroup>
        </div>
       </Card.Body>
       <Card.Footer>
        <div className="d-grid gap-2">
         <IconButton as={Link} icon="shapes" className="fs--1" transform="shrink-2" size="sm" variant="falcon-default" to="new">
          Crear Nuevo Proyecto
         </IconButton>
        </div>
       </Card.Footer>
      </Card>
      <Account />
     </div>
    </Col>
   </Row>
  </>
 );
};

export default Projects;
